import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function DerechosYDeberes() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>
            IX. DERECHOS Y DEBERES DE LOS USUARIOS
          </h4>
          <br></br>
          <p>
            El Usuario gozará de derechos y deberes de conformidad con lo
            establecido en el régimen de protección al consumidor de la Ley 1480
            de 2011.
          </p>
          <p>Entre los derechos del Usuario se encuentran:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p>
                Presentar consultas, peticiones, solicitudes, quejas o reclamos
                de manera respetuosa ante Parking.
              </p>
            </li>
            <li>
              <p>
                Los Usuarios tienen derecho a conocer la Política de Tratamiento
                de Datos Personales, la cual detalla el uso que se dará a su
                información, los derechos que les asisten en relación con el
                tratamiento de sus datos y los canales de atención disponibles
                para ejercer su derecho de hábeas data. Esta política puede ser
                consultada en el siguiente enlace:{' '}
                <a
                  href="www.parking.net.co/politicadetratamientodedatospersonales"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.parking.net.co/politicadetratamientodedatospersonales
                </a>
              </p>
            </li>
            <li>
              <p>
                Solicitar la cancelación o terminación de la relación comercial
                con Parking.
              </p>
            </li>
            <li>
              <p>
                Recibir información completa sobre las tarifas a cobrar por la
                prestación del servicio.
              </p>
            </li>
            <li>
              <p>Recibir información clara, veraz, transparente y oportuna.</p>
            </li>
            <li>
              <p>
                El Derecho de Retracto de conformidad con lo establecido en el
                Capítulo X.
              </p>
            </li>
          </ul>
          <p>Entre los deberes del Usuario se encuentran:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p>
                Ingresar sus Datos Personales de manera veraz al momento de
                registrarse en las Plataformas.
              </p>
            </li>
            <li>
              <p>
                Notificar a Parking de cualquier uso no autorizado de su cuenta
                en las Plataformas.
              </p>
            </li>
            <li>
              <p>
                Abstenerse de utilizar las Plataformas para realizar actos
                contrarios a la moral, la ley, el orden público, y las buenas
                costumbres en contra de Parking, sus operarios y/o de terceros.
              </p>
            </li>
            <li>
              <p>Pagar la tarifa generada por el Servicio.</p>
            </li>
            <li>
              <p>
                Cumplir con las condiciones de prestación del servicio que se
                ponen de presente en el Capítulo VII de estos T&C.
              </p>
            </li>
            <li>
              <p>
                Disponer de fondos suficientes para procesar el pago de los servicios solicitados por medio de las Plataformas.
              </p>
            </li>
            <li>
              <p>
                Abstenerse de registrar métodos de pago que pertenezcan a terceros sin su debida autorización.
              </p>
            </li>
            <li>
              <p>
                Pagar la tarifa generada por el Servicio.
              </p>
            </li>
            <li>
              <p>
                Cumplir con las condiciones de prestación del servicio que se ponen de presente en el Capítulo VII de estos T&C.
              </p>
            </li>
            <li>
              <p>
                Disponer de fondos suficientes para procesar el pago de los servicios solicitados por medio de las Plataformas.
              </p>
            </li>
            <li>
              <p>
                Abstenerse de registrar métodos de pago que pertenezcan a terceros sin su debida autorización.
              </p>
            </li>
            <li>
              <p>
                Registrar los métodos de pago de conformidad con el proceso de verificación en las Plataformas.
              </p>
            </li>
            <li>
              <p>
                Abstenerse de suplantar la identidad de otros Usuarios.
              </p>
            </li>
            <li>
              <p>
                Abstenerse de tener más de una (1) cuenta en las Plataformas con los mismos Datos Personales. El Usuario reconoce y acepta que Parking se reserva el derecho de desactivar las Cuentas que no cumplan con estos parámetros.
              </p>
            </li>
            <li>
              <p>
                Tratar de manera respetuosa a los operarios y a los agentes de servicio al cliente.
              </p>
            </li>
            <li>
              <p>
                Mantener actualizados sus datos de registro.
              </p>
            </li>
            <li>
              <p>
                Asumir las consecuencias, responsabilidades y los perjuicios/daños e inconvenientes que, tanto a al Usuario/Cliente Corporativo mismo como a terceros, se causen por el uso inadecuado de las Plataformas, los mecanismos de autenticación y el incumplimiento de las obligaciones que se pactan en estos T&C.
              </p>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}